import React from 'react'
import { record, recordImpression } from '@paypalcorp/fpti'

const withAnalytics = (Component) => {
  return (props) => <Component {...props} fpti={{ record, recordImpression }} />
}

export default withAnalytics
